const UserRoleSearchCategories = ["pk", "id_unit_kerja", "username", "role"];

export default UserRoleSearchCategories;
